import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mobilelink"
export default class extends Controller {
  static targets = ["link"]
  static values = { href: String }

  connect() {
    if (navigator.userAgent.match(/Mobile|webOS/)) {
      this.linkTarget.href = this.hrefValue
    }
  }

  disconnect() {
  }
}
